import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2),
    },
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '300px',
  },
  tabsContainer: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
    marginTop: theme.spacing(1),
  },
  tab: {
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.95rem',
    minWidth: 140,
    letterSpacing: '0.2px',
  },
  banded: {
    '& > *': {
      padding: '4px',
    },
    '&:nth-child(odd)': {
      backgroundColor: '#f4f4f4',
    },
  },
}))
